
import React from 'react';
import Textfield from './ppbn-textfield';
import passwordValidator from 'common/passwordValidator';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Warning, Check } from '@material-ui/icons';

function passwordAdornment(tempPassword,valid) {                
    if(tempPassword) {            
        let InputProps= {
            startAdornment: (
              <InputAdornment position="start">
                {valid ?  <Check/> : <Warning />}
              </InputAdornment>
            ),
          } 
          return InputProps;
    } else {
        return {};
    }            
};    

export default function (props) {
    const { value } = props; 
    const passwordValid = passwordValidator.validate(value);
    const passwordHintText = passwordValid ? "" : "Password should have at least one uppercase, one lowercase, one special character (#$%), one number and be at least eight characters in length.";

    return (
        <Textfield
            {...props}            
            helperText={passwordHintText}            
            InputProps={passwordAdornment(value, passwordValid)} />
    );         
};


